module.exports = __webpack_public_path__ + "img/logo-ans.d6c58a0d.png";